import gql from 'graphql-tag';

export const CREATE_WAREHOUSE_PATCH = gql`
  mutation createWarehousePatch($warehousePatch: WarehousePatchCreate!) {
    createWarehousePatch(input: { warehousePatch: $warehousePatch }) {
      warehousePatch {
        id
      }
    }
  },
`;

